module.exports = __webpack_public_path__ + "static/media/EXPERT.2af614cd.png";